import React, { useEffect, useState } from 'react';

import styles from './new-booking-request-modal.module.scss';
import Modal from '../../../../../shared/components/core-ui/modal/modal.component';
import Button from '../../../../../shared/components/core-ui/button/button.component';

import {
  InputText,
  InputTextType
} from '../../../../../shared/components/core-ui/input-text/input-text.component';
import { ReservationChannel } from '../../../../../shared/enums/reservation-channel.enum';
import Select, { ValueType } from 'react-select';
import { ReservationSource } from '../../../../../shared/enums/reservation-souce.enum';
import COUNTRIES from '../../../../../ReservationModule/containers/reservation-edit-new/components/add-guest-modal/countries.json';
import ReactDatePicker from 'react-datepicker';
import { store } from 'react-notifications-component';
import { isErrorInfo, ErrorInfo } from '../../../../../shared/interfaces/error-info.interface';
import { createNewBookingRequest } from '../../../../shared/services/data.service';
import moment from 'moment';
import { getAllAreas } from '../../../../../shared/services/data/lookups.data';
import { getModuleName } from '../../../../shared/services/booking.service';
import { AreaUiModel } from '../../../../../shared/ui-models/area.ui-model';
import { PropertyUiModel } from '../../../../../shared/ui-models/property.ui-model';
import { getAllProperties } from '../../../../../PropertyModule/shared/services/data.service';
import { BookingRequestUiModel } from '../../../../../shared/ui-models/booking-request.ui-model';
import { getAllUnitTypes } from '../../../../../shared/services/data/unit-type.data';
import {
  UnitTypeUiModel,
  UnitTypeUiModelResponse
} from '../../../../../shared/ui-models/unit-type.ui-model';

export interface newBookingRequestModalProps {
  config: {
    showModal: boolean;
    editData?: BookingRequestUiModel;
  };
  eventHandlers: {
    closeHandler: (update?: boolean) => void;
    updateHandler?: (data: BookingRequestUiModel) => void;
  };
}

const GENDER_OPTION = [
  { label: 'Male', value: 'male' },
  { label: 'FeMale', value: 'female' }
];

/**
 * functional component AccountManagerPersonModal
 * @param {newBookingRequestModalProps}
 */
export const CreateBookingRequestModal: React.FC<newBookingRequestModalProps> = ({
  config,
  eventHandlers
}) => {
  const [selectedChannel, setSelectedChannel] = useState<ReservationChannel | undefined>(undefined);
  const [source, setSource] = useState<ReservationSource | undefined>(undefined);
  const [mobileNumber, setMobileNumber] = useState<string | undefined>(undefined);
  const [email, setEmail] = useState<string | undefined>(undefined);
  const [guestName, setGuestName] = useState<string | undefined>(undefined);
  const [age, setAge] = useState<number | undefined>(undefined);
  const [gender, setGender] = useState<string | undefined>(undefined);
  const [nationality, setNationality] = useState<string>('');
  const [numberOfGuests, setNumberOfGuests] = useState<number | undefined>(undefined);
  const [numberOfBedrooms, setNumberOfBedrooms] = useState<number | undefined>(undefined);
  const [unitTypeId, setUnitTypeId] = useState<number | undefined>(undefined);
  const [specialRequest, setSpecialRequest] = useState<string>('');
  const [CheckInDate, setCheckInDate] = useState<Date>();
  const [checkoutDate, setCheckoutDate] = useState<Date>();
  const [specificBudget, setSpecificBudget] = useState<{ from: number; to: number } | undefined>(
    undefined
  );
  const [areaOptions, setAreaOptions] = useState<{ value: string; label: string }[]>([]);
  const [projectsList, setProjectsList] = useState<PropertyUiModel[]>([]);
  const [projectsOptions, setProjectsOptions] = useState<PropertyUiModel[]>([]);
  const [allUnitTypesList, setAllUnitTypesList] = useState<UnitTypeUiModel[]>([]);
  const [unitTypesOptions, setUnitTypesOptions] = useState<UnitTypeUiModel[]>([]);

  const [area, setArea] = useState('');
  const [project, setProject] = useState<string | undefined>(undefined);

  function handleCreateBookingRequest() {
    const data = {
      channel: selectedChannel || undefined,
      source: source || undefined,
      name: guestName || undefined,
      phoneNumber: mobileNumber || undefined,
      nationality: nationality || undefined,
      email: email || undefined,
      age: age || undefined,
      numberOfGuests: numberOfGuests || undefined,
      interestedBedrooms: numberOfBedrooms || undefined,
      specialRequest: specialRequest || undefined,
      gender: gender || undefined,
      checkInDate: CheckInDate ? moment(CheckInDate).valueOf() : undefined,
      checkOutDate: checkoutDate ? moment(checkoutDate).valueOf() : undefined,
      budgetFrom: specificBudget?.from,
      budgetTo: specificBudget?.to,
      interestedLocation: area || undefined,
      interestedProject: project || undefined,
      unitTypeId: unitTypeId || undefined
    };

    if (config.editData) {
      eventHandlers.updateHandler?.(data as any);
      return;
    }

    createNewBookingRequest(data).then((response) => {
      if (!isErrorInfo(response)) {
        eventHandlers.closeHandler(true);
      } else {
        store.addNotification({
          id: 'add-user-failed',
          title: 'Create Reservation',
          message: response?.errorMessage,
          type: 'danger',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 3000,
            onScreen: true
          }
        });
      }
    });
  }

  useEffect(() => {
    getAllAreas(getModuleName()).then((response: AreaUiModel[] | ErrorInfo) => {
      if (!isErrorInfo(response)) {
        setAreaOptions(response.map((area) => ({ value: area.name || '', label: area.name })));
      }
    });

    getAllProperties().then((response: PropertyUiModel[] | ErrorInfo) => {
      if (!isErrorInfo(response)) {
        setProjectsList(response);
      }
    });

    getAllUnitTypes(getModuleName(), 0, -1, {}).then(
      (response: UnitTypeUiModelResponse | ErrorInfo) => {
        if (!isErrorInfo(response)) {
          setAllUnitTypesList(response?.unitList);
        }
      }
    );
    if (config.editData) {
      const editData = config.editData;

      setSelectedChannel(editData?.channel as any);
      setSource(editData?.source as any);
      setGuestName(editData?.guestInfo?.name);
      setMobileNumber(editData?.guestInfo?.phoneNumber);
      setEmail(editData?.guestInfo?.email);
      setNationality(editData?.nationality || '');
      setAge(editData?.age);
      setNumberOfGuests(editData?.bookingInfo?.numberOfGuests);
      setNumberOfBedrooms(editData?.interestedBedrooms);
      setSpecialRequest(editData?.specialRequest || '');
      setGender(editData?.guestInfo?.gender || '');
      setArea(editData?.interestedLocation || '');
      if (editData?.interestedLocation) {
        setProjectsOptions(projectsList.filter((p) => p.areaName === editData?.interestedLocation));
      }
      setProject(editData?.interestedProject || '');
      if (editData?.interestedProject) {
        setUnitTypesOptions(
          allUnitTypesList.filter((unit) => unit.propertyName === editData?.interestedProject)
        );
      }
      setCheckInDate(
        editData?.bookingInfo?.checkInDate
          ? new Date(editData?.bookingInfo?.checkInDate)
          : undefined
      );
      setCheckoutDate(
        editData?.bookingInfo?.checkOutDate
          ? new Date(editData?.bookingInfo?.checkOutDate)
          : undefined
      );
      setSpecificBudget(
        editData?.budgetFrom && editData?.budgetTo
          ? { from: editData?.budgetFrom, to: editData?.budgetTo }
          : undefined
      );
      setUnitTypeId(Number(editData?.bookingInfo?.unitTypeId) || undefined);
    }
  }, []);

  return (
    <Modal
      config={{
        showModal: config.showModal,
        fullScreen: false,
        showClose: true,
        className: 'partner-Modal'
      }}
      eventHandlers={{
        closeModalHandler: () => {
          eventHandlers.closeHandler();
        }
      }}
    >
      <div className={styles['create-booking-request-container__title']}>
        {!config.editData ? 'Create New Booking Request' : 'Edit Booking Request'}
      </div>
      <div className={styles['create-booking-request-container']}>
        <div>
          Select Channel
          <Select
            defaultValue={
              selectedChannel
                ? {
                    value: selectedChannel,
                    label: selectedChannel.replaceAll('-', ' ')?.toUpperCase()
                  }
                : undefined
            }
            className={styles['create-booking-request-container__select']}
            options={[
              ...Object.values(ReservationChannel),
              'WhatsApp',
              'CallCenter',
              'Instagram',
              'Messenger',
              'Referral'
            ].map((value) => ({
              label: value?.toUpperCase(),
              value: value
            }))}
            onChange={(value: ValueType<{ value: string | undefined; label: string }, false>) => {
              setSelectedChannel(value?.value);
            }}
          />
          Select Source
          <Select
            defaultValue={
              source
                ? { value: source, label: source.replaceAll('-', ' ')?.toUpperCase() }
                : undefined
            }
            className={styles['create-booking-request-container__select']}
            options={Object.values(ReservationSource)?.map((s) => ({
              value: s,
              label: s.replaceAll('-', ' ')?.toUpperCase()
            }))}
            onChange={(value: ValueType<{ value: string | undefined; label: string }, false>) => {
              setSource(value?.value);
            }}
          />
          Guest Name
          <InputText
            data={{
              value: guestName || '',
              placeholder: 'Enter guest name'
            }}
            config={{
              maxRows: 1,
              autoFocus: false,
              type: InputTextType.text,
              required: true
            }}
            eventHandlers={{
              onChangeHandler: (value: string) => {
                setGuestName(value);
              }
            }}
          />
          <div style={{ marginTop: '1rem' }}>
            Mobile Number
            <InputText
              data={{
                value: mobileNumber || '',
                placeholder: 'Enter mobile number'
              }}
              config={{
                maxRows: 1,
                autoFocus: false,
                type: InputTextType.text,
                required: true
              }}
              eventHandlers={{
                onChangeHandler: (value: string) => {
                  setMobileNumber(value);
                }
              }}
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            Nationality
            <Select
              isSearchable
              options={COUNTRIES}
              defaultValue={COUNTRIES.find((val) => val.value === nationality)}
              onChange={(value: ValueType<{ value: string; label: string }, false>) => {
                if (!value) return;

                setNationality(value?.value);
              }}
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            Email
            <InputText
              data={{
                value: email || '',
                placeholder: 'Enter email'
              }}
              config={{
                maxRows: 1,
                autoFocus: false,
                type: InputTextType.email
              }}
              eventHandlers={{
                onChangeHandler: (value: string) => {
                  setEmail(value);
                }
              }}
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            Age
            <InputText
              data={{
                value: age ? age.toString() : '',
                errorMessage: 'Age is required',
                placeholder: 'Age'
              }}
              config={{
                maxRows: 1,
                type: InputTextType.number
              }}
              eventHandlers={{
                onChangeHandler: (value: string) => {
                  setAge(Number(value));
                }
              }}
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            Number of Guests
            <InputText
              data={{
                value: numberOfGuests ? numberOfGuests.toString() : '',
                placeholder: 'Number of Guests'
              }}
              config={{
                maxRows: 1,
                type: InputTextType.number
              }}
              eventHandlers={{
                onChangeHandler: (value: string) => {
                  setNumberOfGuests(Number(value));
                }
              }}
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            Interested Number of Bedrooms
            <InputText
              data={{
                value: numberOfBedrooms ? numberOfBedrooms.toString() : '',
                placeholder: 'Number of Bedrooms'
              }}
              config={{
                maxRows: 1,
                type: InputTextType.number
              }}
              eventHandlers={{
                onChangeHandler: (value: string) => {
                  setNumberOfBedrooms(Number(value));
                }
              }}
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            Special Request
            <InputText
              data={{
                value: specialRequest || '',
                placeholder: 'Enter special request'
              }}
              config={{
                maxRows: 3,
                type: InputTextType.textarea
              }}
              eventHandlers={{
                onChangeHandler: (value: string) => {
                  setSpecialRequest(value);
                }
              }}
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            Gender
            <Select
              value={{
                value: gender,
                label: GENDER_OPTION.find((val) => val.value === gender)?.label
              }}
              options={GENDER_OPTION}
              defaultValue={GENDER_OPTION.find((val) => val.value === gender)}
              onChange={(value: ValueType<{ value: string; label: string }, false>) => {
                setGender(value?.value || 'male');
              }}
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            Interested Location
            <Select
              value={{ value: area, label: area }}
              options={areaOptions}
              defaultValue={areaOptions.find((val) => val.value === area)}
              onChange={(value: ValueType<{ value: string; label: string }, false>) => {
                setProjectsOptions(projectsList.filter((p) => p.areaName === value?.value));
                setUnitTypeId(undefined);
                setUnitTypesOptions([]);
                setProject(undefined);
                setArea(value?.value || '');
              }}
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            Interested Project
            <Select
              value={{
                value: project,
                label: project
              }}
              options={projectsOptions.map((proj) => ({
                value: proj.name || '',
                label: proj.name || ''
              }))}
              defaultValue={projectsOptions
                .map((proj) => ({
                  value: proj.name || '',
                  label: proj.name || ''
                }))
                .find((val) => val.value === project)}
              onChange={(value: ValueType<{ value: string; label: string }, false>) => {
                setUnitTypesOptions(
                  allUnitTypesList.filter((unit) => unit.propertyName === value?.value)
                );
                setUnitTypeId(undefined);
                setProject(value?.value || '');
              }}
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            Unit Type
            <Select
              value={{
                value: unitTypeId?.toString() || '',
                label:
                  allUnitTypesList
                    .map((unit) => ({
                      value: unit.id || '',
                      label: unit.name || ''
                    }))
                    .find((u) => u.value?.toString() === unitTypeId?.toString())?.label || ''
              }}
              options={unitTypesOptions.map((unit) => ({
                value: unit.id?.toString() || '',
                label: unit.name || ''
              }))}
              defaultValue={allUnitTypesList
                .map((unit) => ({
                  value: unit.id?.toString() || '',
                  label: unit.name || ''
                }))
                .find((val) => val.value === unitTypeId?.toString())}
              onChange={(value: ValueType<{ value: string; label: string }, false>) => {
                setUnitTypeId(Number(value?.value) || undefined);
              }}
            />
          </div>
          <div style={{ marginTop: '1rem' }}>
            Check-in - Check-out
            <div className={styles['create-booking-request-container__date-range']}>
              <ReactDatePicker
                selected={CheckInDate}
                onChange={(date: Date) => {
                  setCheckInDate(date);
                  setCheckoutDate(undefined);
                }}
                selectsStart
                startDate={CheckInDate}
                endDate={checkoutDate}
                placeholderText="check-in Date"
              />
              <ReactDatePicker
                selected={checkoutDate}
                onChange={(date: Date) => setCheckoutDate(date)}
                selectsEnd
                startDate={CheckInDate}
                endDate={checkoutDate}
                minDate={CheckInDate}
                placeholderText="check-out Date"
              />
            </div>
          </div>
          <div style={{ marginTop: '1rem' }}>
            Specific Budget
            <div className={styles['create-booking-request-container__date-range']}>
              <InputText
                data={{
                  value: specificBudget ? specificBudget.from.toString() : '',
                  placeholder: 'from'
                }}
                config={{
                  maxRows: 1,
                  type: InputTextType.number
                }}
                eventHandlers={{
                  onChangeHandler: (value: string) => {
                    setSpecificBudget({
                      from: Number(value) || 0,
                      to: specificBudget?.to || 0
                    });
                  }
                }}
              />
              <InputText
                data={{
                  value: specificBudget ? specificBudget.to.toString() : '',
                  placeholder: 'to'
                }}
                config={{
                  maxRows: 1,
                  type: InputTextType.number
                }}
                eventHandlers={{
                  onChangeHandler: (value: string) => {
                    setSpecificBudget({
                      from: specificBudget?.from || 0,
                      to: Number(value) || 0
                    });
                  }
                }}
              />
            </div>
          </div>
          <div className={styles['create-booking-request-container--actions']}>
            <Button
              onClick={() => {
                eventHandlers.closeHandler();
              }}
              tracking={{ event: 'record_edit_cancelled', entity: 'reservation', method: 'cancel' }}
            >
              Cancel
            </Button>
            <Button
              disabled={!mobileNumber || !guestName}
              onClick={handleCreateBookingRequest}
              tracking={{
                event: 'record_saved',
                entity: 'reservation',
                action: 'create',
                outcome: 'success'
              }}
            >
              {!config.editData ? 'Create' : 'Update'}
            </Button>
          </div>
        </div>
        <div />
      </div>
    </Modal>
  );
};
